<template>
	<div class="" id="aqeba">
		<section class="landing jumbotron jumbotron-fluid">
			<v-container
				class="d-flex align-content-center"
				r
				style="height: 100vh"
			>
				<v-row class="">
					<v-col
						class="col-md-6 d-none d-sm-none d-md-block d-lg-block"
					>
						<v-img
							class="d-flex mx-auto"
							lazy-src="@/assets/images/women-day-rafiki.svg"
							src="@/assets/images/women-day-rafiki.svg"
						></v-img>
					</v-col>
					<v-col
						class="col-md-6 col-sm-8 text-lg-right text-md-right text-sm-left my-auto"
						align-self="center"
					>
						<h2 class="display-3 font-weight-medium white--text">
							Save More, Win More
						</h2>
						<p
							class="lead text-lg-right text-md-right text-sm-left white--text"
						>
							With Aqeba, you can save and invest without <br />
							worrying about diminished returns
						</p>
						<div class="d-flex">
							<v-btn
								rounded
								large
								class="ml-md-auto mr-sm-auto font-weight-medium text--accent"
								@click="
									$vuetify.goTo(aboutAqebaTarget, options)
								"
							>
								About Aqeba
								<v-icon right dark>
									mdi-arrow-down
								</v-icon>
							</v-btn>
							<!-- <a href="#" class="btn btn-lg d-block ml-auto"></a> -->
						</div>
					</v-col>
				</v-row>
			</v-container>
		</section>
		<section class="features pt-15" id="features">
			<v-container class="py-md-15">
				<v-row>
					<v-col class="aqeba-features col-md-6 order-sm-0">
						<h3 class="mb-5">Features</h3>
						<div class="d-flex flex-wrap">
							<div class="bg-white feature">
								<v-img
									class="mb-3 d-flex mx-auto"
									lazy-src="@/assets/images/savings-rafiki.svg"
									max-height="180px"
									max-width="180px"
									src="@/assets/images/savings-rafiki.svg"
								></v-img>
								<p class="text-center accent--text">
									User Deposits
								</p>
							</div>
							<div class="bg-white feature">
								<v-img
									class="mb-3 d-flex mx-auto"
									lazy-src="@/assets/images/credit-card-rafiki.svg"
									max-height="180px"
									max-width="180px"
									src="@/assets/images/credit-card-rafiki.svg"
								></v-img>
								<p class="text-center accent--text">
									Withdrawals
								</p>
							</div>
						</div>
						<div class="d-flex flex-wrap">
							<div class="bg-white feature ">
								<v-img
									class="mb-3 d-flex mx-auto"
									lazy-src="@/assets/images/winners-rafiki.svg"
									max-height="180px"
									max-width="180px"
									src="@/assets/images/winners-rafiki.svg"
								></v-img>
								<p class="text-center accent--text">
									Prizes
								</p>
							</div>
							<div class="bg-white feature">
								<v-img
									class="mb-3 d-flex mx-auto"
									lazy-src="@/assets/images/analytics-rafiki.svg"
									max-height="180px"
									max-width="180px"
									src="@/assets/images/analytics-rafiki.svg"
								></v-img>
								<p class="text-center accent--text">
									Analytics
								</p>
							</div>
						</div>
					</v-col>
					<v-col class="about-aqeba col-md-6 order-sm-1">
						<h3 class="mb-5">About</h3>
						<p>
							Aqeba® Digital Premium Bonds is an investment
							platform which aims to foster a new savings and
							investment culture among Kenyans. It is a digital
							product to assist Kenyans build their financial
							stability by providing a risk-free investment model.
						</p>
						<p>
							Save and invest your money with Aqeba. Unlock the
							chance to win attractive prizes every week and
							month. There is no catch...you can't lose.
						</p>
						<div class="d-flex">
							<v-btn
								rounded
								large
								class="ml-lg-auto ml-xl-auto ml-md-auto mr-sm-auto"
								@click="
									$vuetify.goTo(howItWorksTarget, options)
								"
							>
								How it works
								<v-icon right dark>
									mdi-arrow-down
								</v-icon>
							</v-btn>
						</div>
					</v-col>
				</v-row>
			</v-container>
			<v-container class="how-it-works pt-15" id="how-it-works">
				<v-row class="pt-md-15">
					<v-col class="col-md-6">
						<h3>How it works</h3>
						<p>
							Aqeba® Digital Premium Bonds will first be available
							as a USSD application. Anyone with a handset can
							begin saving and investing with Aqeba by dialing
							*USSD#.
						</p>
						<v-btn
							rounded
							large
							class="ml-auto"
							@click="$vuetify.goTo(firstLaunchTarget, options)"
						>
							First Launch
							<v-icon right dark>
								mdi-arrow-down
							</v-icon>
						</v-btn>
					</v-col>
					<div class="illustration">
						<img src="@/assets/images/how-it-works.svg" />
					</div>
				</v-row>
			</v-container>
		</section>
		<section class="first-launch" id="first-launch">
			<v-container fluid>
				<v-row align="center">
					<v-col
						class="col-md-4 d-none d-md-block d-lg-block d-xl-block"
					>
						<v-img
							contain
							height="550px"
							max-height="100%"
							class="d-flex mx-auto"
							lazy-src="@/assets/images/Businessman-rafiki.svg"
							src="@/assets/images/Businessman-rafiki.svg"
						></v-img>
					</v-col>
					<v-col class="col-md-4 col-sm-8">
						<h3
							class="text-lg-center text-md-center text-sm-left text-xs-left"
						>
							Make Aqeba Happen
						</h3>
						<p
							class="text-lg-center text-md-center text-sm-left text-xs-left"
						>
							If you like investing and want exciting returns,
							jump into Aqeba today! We guarantee the safety and
							security of your money. There are no losses with
							Aqeba
						</p>
					</v-col>
					<v-col class="col-md-4 col-sm-4">
						<v-img
							class="d-flex mx-auto"
							contain
							height="550px"
							max-height="100%"
							lazy-src="@/assets/images/happy-woman.svg"
							src="@/assets/images/happy-woman.svg"
						></v-img>
					</v-col>
				</v-row>
			</v-container>
		</section>
		<section class="footer">
			<v-container>
				<v-btn
					rounded
					large
					class="back-to-top ml-auto"
					@click="$vuetify.goTo(topTarget, options)"
				>
					Back to top
					<v-icon right class="white--text bg-blue rounded">
						mdi-arrow-up
					</v-icon>
				</v-btn>
				<v-row>
					<v-col
						class="col-md-8 offset-md-2 col-sm-8 offset-sm-2 text-center px-lg-15"
					>
						<h3 class="small text-center white--text mb-4">
							Aqeba Launch
						</h3>
						<p class="text-center white--text">
							Get notified when Aqeba USSD launches.
						</p>
						<ValidationObserver ref="obs" v-slot="{}">
							<v-form>
								<ValidationProvider
									name="Phone Number"
									rules="required"
								>
									<v-row>
										<div class="col-md-5 col-sm-12">
											<v-text-field
												dense
												background-color="#fff"
												v-model="fullName"
												rounded
												filled
												label="Full Name"
												type="text"
												class="custom-input"
											></v-text-field>
										</div>
										<div class="col-md-7 col-sm-12">
											<v-text-field
												dense
												background-color="#fff"
												v-model="phoneNumber"
												:append-icon="'mdi-arrow-right'"
												:append-icon:loading="isLoading"
												rounded
												filled
												label="Phone Number"
												v-mask="'+############'"
												type="tel"
												@click:append="sendMessage()"
												class="custom-input"
											></v-text-field>
										</div>
									</v-row>
								</ValidationProvider>
							</v-form>
						</ValidationObserver>
						<ul class="footer-nav text-center pl-0">
							<li
								class="list-inline-item"
								v-for="(link, index) in links"
								:key="index"
							>
								<a v-bind:href="link.url">{{ link.title }}</a>
							</li>
						</ul>
						<p class="text-center pt-15 white--text">
							© 2020 Aqeba. All Rights Reserved.
						</p>
					</v-col>
				</v-row>
			</v-container>
		</section>
		<v-snackbar color="primary" v-model="snackbar" :timeout="timeout">
			{{ snackbarMessage }}
		</v-snackbar>
	</div>
</template>

<script>
	import {subscriptionAPI} from "@/api/subscription"

	export default {
		name: "Home",
		data: () => ({
			isLoading: false,
			snackbar: false,
			snackbarMessage: "",
			timeout: 4000,
			fullName: "",
			phoneNumber: "",
			aboutAqebaTarget: "#features",
			howItWorksTarget: "#how-it-works",
			firstLaunchTarget: "#first-launch",
			topTarget: "#aqeba",
			options: [],
			links: [
				{
					title: "FAQs",
					url: "#",
				},
				{
					title: "Terms & Conditions",
					url: "#",
				},
				{
					title: "Privacy Policy",
					url: "#",
				},
			],
		}),
		methods: {
			sendMessage() {
				var current = this
				this.isLoading = true
				subscriptionAPI
					.post("/users", {
						user: {
							app_id: process.env.VUE_APP_ID,
							full_name: this.fullName,
							phone_number: this.phoneNumber,
						},
					})
					.then(function(response) {
						console.log(response.data)
						current.snackbarMessage =
							"Glad to have you onboard. We will notify you on " +
							response.data.data.phone_number +
							"."
					})
					.catch(function(error) {
						current.snackbarMessage = error
					})
					.finally(function() {
						current.snackbar = true
						current.clearMessage()
					})
			},
			clearMessage() {
				this.fullName = ""
				this.phoneNumber = ""
			},
		},
	}
</script>
